/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomefieldButtonComponent } from './button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HomefieldButtonComponent],
  exports: [HomefieldButtonComponent],
})
export class HomefieldButtonModule {}
